import { Box, Container } from '@mui/material';
import React from 'react';
import useWindowSize from '../infrastructure/hooks/useWindowSize';

const MainContainer: React.FC = ({ children }) => {
  const { isNarrow } = useWindowSize();
  return (
    <Container
      maxWidth={isNarrow ? 'lg' : 'xl'}
      sx={{ height: 'calc(100% - 64px)' }}
    >
      <Box py={2} height="calc(100% - 64px)" maxHeight="100%">
        {children}
      </Box>
    </Container>
  );
};

export default MainContainer;
